module.exports = __webpack_public_path__ + "static/img/ligo_05.eeb09a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jobImage/jobScreenShot/ligo_05.png
// module id = e3xk
// module chunks = 0